module.exports = __webpack_public_path__ + "static/bloodtainted-greatsword-da94621b1e7017e396cc1186548759ec.png";